import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Recovered ancient post, implemented with DirectX or RenderMonkey (Offline Shadertoys)`}</p>
    <h1>{`Transmittance of Light`}</h1>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "244px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/b70df484e9a6a3b9e2dfdc2075aa0de8/603fe/elephant-deep-peeling.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "97.33333333333333%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAATABQDASIAAhEBAxEB/8QAGQABAQADAQAAAAAAAAAAAAAAAAMCBAUG/8QAFwEAAwEAAAAAAAAAAAAAAAAAAAEDBP/aAAwDAQACEAMQAAABvht8jPL0ya9KTAqG/wD/xAAdEAACAgIDAQAAAAAAAAAAAAABAwACERIEEyEi/9oACAEBAAEFAnvsL05foIIesTq+ljCyMzSu0//EABYRAQEBAAAAAAAAAAAAAAAAAAERIP/aAAgBAwEBPwFo4//EABYRAQEBAAAAAAAAAAAAAAAAAAEgIf/aAAgBAgEBPwFxj//EABwQAAIBBQEAAAAAAAAAAAAAAAABEQIQEiExUf/aAAgBAQAGPwJpaSFkShuOkFKXhs5b/8QAGxABAQEAAwEBAAAAAAAAAAAAAREAITFBcVH/2gAIAQEAAT8hYinzeo+42lHrOJ0HP3Xf4Li6xgGCm5LNmCEN/9oADAMBAAIAAwAAABCo/wB8/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQAQMf/aAAgBAwEBPxBQOSZ//8QAGBEBAAMBAAAAAAAAAAAAAAAAAQAQETH/2gAIAQIBAT8QSmsHTYg9r//EABwQAQEBAAIDAQAAAAAAAAAAAAERACFBMWFxgf/aAAgBAQABPxBJsTorrS8WIbT5gXDqOzLKgLs4R3TA5PrXggS6dqdOPKRH58wAAB4Df//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Figure 1: Elephant Depth Peeling",
            "title": "Figure 1: Elephant Depth Peeling",
            "src": "/static/b70df484e9a6a3b9e2dfdc2075aa0de8/603fe/elephant-deep-peeling.jpg",
            "srcSet": ["/static/b70df484e9a6a3b9e2dfdc2075aa0de8/75985/elephant-deep-peeling.jpg 150w", "/static/b70df484e9a6a3b9e2dfdc2075aa0de8/603fe/elephant-deep-peeling.jpg 244w"],
            "sizes": "(max-width: 244px) 100vw, 244px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Figure 1: Elephant Depth Peeling`}</figcaption>{`
  `}</figure>


    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "102px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/29a9aa5ed70d99af05852e5450f081d3/7d61e/lucy-depth-peeling.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "239.2156862745098%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAwABQDASIAAhEBAxEB/8QAGQAAAwEBAQAAAAAAAAAAAAAAAAMEAgEF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAwL/2gAMAwEAAhADEAAAAfcQnBQ84LeoroAOwB0bG+YopMi3/8QAHxAAAgICAQUAAAAAAAAAAAAAAgMBMgQREgAhIiMz/9oACAEBAAEFAj3IY++DrZBFBIKebrZHYEz5utkR61Rsm2f8sazrPnl0qJEmlEl//8QAGBEAAwEBAAAAAAAAAAAAAAAAARAhETL/2gAIAQMBAT8B2o9Iir//xAAYEQADAQEAAAAAAAAAAAAAAAABAhAiMv/aAAgBAgEBPwEtqP1CNT//xAAdEAABBAIDAAAAAAAAAAAAAAABABARIQJhIDJx/9oACAEBAAY/AjCtoBpa5UxeMchHq7ADZVFf/8QAHBAAAwADAQEBAAAAAAAAAAAAAAERITFxQVEQ/9oACAEBAAE/IVQNHBUerk08FTQ1jsXI08HWjLwTQ08LX8Y+Gxr4LfwdPCJfRLBim17kBEaHjxn/2gAMAwEAAgADAAAAEBzKPNfP/8QAFxEBAQEBAAAAAAAAAAAAAAAAARARIf/aAAgBAwEBPxBHM3iIln//xAAWEQEBAQAAAAAAAAAAAAAAAAABEBH/2gAIAQIBAT8QAJNZjJcn/8QAHxABAAIBBQADAAAAAAAAAAAAAQARIUFRYaGxMXGB/9oACAEBAAE/ELXzgxUULodIkqUx+HlgnxUAzcKXah+TpfWWsF5as1HrmLzOl9ZZbJjULozWbfWJUaBF+rmVzZnS+sRR5VGyW7hipTioTHqXZqz/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Figure 1: Lucy Depth Peeling",
            "title": "Figure 1: Lucy Depth Peeling",
            "src": "/static/29a9aa5ed70d99af05852e5450f081d3/7d61e/lucy-depth-peeling.jpg",
            "srcSet": ["/static/29a9aa5ed70d99af05852e5450f081d3/7d61e/lucy-depth-peeling.jpg 102w"],
            "sizes": "(max-width: 102px) 100vw, 102px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Figure 1: Lucy Depth Peeling`}</figcaption>{`
  `}</figure>
    <center></center>
    <p>{`Fig 1 is a very simple implementation in Rendermonkey, using Fresnel item to control the light transmittance. There are many dirty works for packing the float to a rgba texture(I don’t know how to manipulate the depth texture in Rendermonkey!). What’s more, you have to be very careful about the texture coordinates, even there was only 1/2 pixel’s offset.`}</p>
    <h1>{`BTF`}</h1>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "244px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/09958ca9b4e35009900a1516a59ee3b7/603fe/btf-teapot.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "93.33333333333333%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAATABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAMCBQT/xAAWAQEBAQAAAAAAAAAAAAAAAAADAAH/2gAMAwEAAhADEAAAAeLefrcOaoFp6MsC3//EABoQAAMBAAMAAAAAAAAAAAAAAAABAhEDEBP/2gAIAQEAAQUCidPPSljhmnI06G31/8QAGREAAQUAAAAAAAAAAAAAAAAAAQACEBEx/9oACAEDAQE/AXE2hk//xAAZEQABBQAAAAAAAAAAAAAAAAABAAIQETH/2gAIAQIBAT8BYBSOz//EABYQAAMAAAAAAAAAAAAAAAAAABARIP/aAAgBAQAGPwIK/wD/xAAaEAACAwEBAAAAAAAAAAAAAAAAAREhMUFR/9oACAEBAAE/IU6GnEEu3BFECoirD0EH/9oADAMBAAIAAwAAABB06Pz/xAAYEQEAAwEAAAAAAAAAAAAAAAABABARIf/aAAgBAwEBPxA3EShZhtf/xAAYEQEBAAMAAAAAAAAAAAAAAAABABARIf/aAAgBAgEBPxBfUQQQusf/xAAaEAEBAQEBAQEAAAAAAAAAAAABEQAhQTFR/9oACAEBAAE/EA7a+GP7ScTmT7BYkHvLiHXOXqEXJfUyiKjo/N//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Figure 2: BTF",
            "title": "Figure 2: BTF",
            "src": "/static/09958ca9b4e35009900a1516a59ee3b7/603fe/btf-teapot.jpg",
            "srcSet": ["/static/09958ca9b4e35009900a1516a59ee3b7/75985/btf-teapot.jpg 150w", "/static/09958ca9b4e35009900a1516a59ee3b7/603fe/btf-teapot.jpg 244w"],
            "sizes": "(max-width: 244px) 100vw, 244px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Figure 2: BTF`}</figcaption>{`
  `}</figure>
    <p>{`As in Fig 2, it is a very interest way to simulate the SVBRDF, especially useful to simulate the wool or sweater –such kinda rough surface, and the data for rendering is accessible `}<a parentName="p" {...{
        "href": "http://btf.cs.uni-bonn.de/download.html"
      }}>{`here`}</a>{`. You can get these data yourself with your DC. I think it’s sort of image based rendering, a quick implementation stuff can be found `}<a parentName="p" {...{
        "href": "http://http.developer.nvidia.com/GPUGems2/gpugems2_chapter11.html"
      }}>{`here`}</a>{` by Jan Kautz. I use the Matlab to process the image got here. And I interpolate these pictures based on average intensity of pictures.`}</p>
    <h1>{`Classical Lighting`}</h1>
    <p>{`Most of the lighting is computed in an environment with single point light. I read a lot of papers on BRDF, and I just picked up certain light mode to implement. Anisotropic light is even more complex in environment lighting.`}</p>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "244px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/a837ddc3d0a8a9c11668a1abaa28754e/603fe/bronze-cook.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "72%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAOABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAgADBf/EABUBAQEAAAAAAAAAAAAAAAAAAAED/9oADAMBAAIQAxAAAAHmIaMRGT//xAAaEAEAAgMBAAAAAAAAAAAAAAABAAIDEBEh/9oACAEBAAEFAvWNE0PJbI2J/8QAFhEBAQEAAAAAAAAAAAAAAAAAEQEQ/9oACAEDAQE/AYGf/8QAFREBAQAAAAAAAAAAAAAAAAAAECH/2gAIAQIBAT8Bp//EABcQAAMBAAAAAAAAAAAAAAAAAAEQESD/2gAIAQEABj8CxCv/xAAaEAEAAwADAAAAAAAAAAAAAAABABExECFB/9oACAEBAAE/Ib9GF2nUu9YmIWwOP//aAAwDAQACAAMAAAAQNw//xAAXEQADAQAAAAAAAAAAAAAAAAAAESEx/9oACAEDAQE/EKnoz//EABgRAAMBAQAAAAAAAAAAAAAAAAABESEx/9oACAECAQE/EHpThD//xAAZEAEAAwEBAAAAAAAAAAAAAAABABExIRD/2gAIAQEAAT8QwKXzrANZFilRfYjmMQVbo9I3hTRR5//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Figure 3: Cook and Torrance [1981]",
            "title": "Figure 3: Cook and Torrance [1981]",
            "src": "/static/a837ddc3d0a8a9c11668a1abaa28754e/603fe/bronze-cook.jpg",
            "srcSet": ["/static/a837ddc3d0a8a9c11668a1abaa28754e/75985/bronze-cook.jpg 150w", "/static/a837ddc3d0a8a9c11668a1abaa28754e/603fe/bronze-cook.jpg 244w"],
            "sizes": "(max-width: 244px) 100vw, 244px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Figure 3: Cook and Torrance [1981]`}</figcaption>{`
  `}</figure>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "158px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/3f30c941402abf000c7256449e8f882d/ff44c/lucy-banks.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "154.66666666666666%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAIDBAEG/8QAFAEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAAB8/fVrTMBWOJBMP8A/8QAHBAAAgICAwAAAAAAAAAAAAAAAQIAAwQREiMy/9oACAEBAAEFApaFVli+sk9olY2953cInNCwdiEaf//EABURAQEAAAAAAAAAAAAAAAAAABBB/9oACAEDAQE/AaU//8QAFREBAQAAAAAAAAAAAAAAAAAAEEH/2gAIAQIBAT8BhD//xAAbEAACAwADAAAAAAAAAAAAAAAAAQIQESExgf/aAAgBAQAGPwIyPtIkqRKuEazo/8QAGxAAAgMBAQEAAAAAAAAAAAAAAAERITFhQaH/2gAIAQEAAT8hLwZrxmD6hqQi96ZIf0W4k0umRG2l1DTI22RB/9oADAMBAAIAAwAAABAoDwz/xAAXEQEBAQEAAAAAAAAAAAAAAAABECER/9oACAEDAQE/EFwTjqf/xAAXEQEBAQEAAAAAAAAAAAAAAAABECER/9oACAECAQE/EA0zpif/xAAeEAEAAgICAwEAAAAAAAAAAAABABEhMUGBUXHRYf/aAAgBAQABPxALaNwbngp2AiR55hsQtrjuDkML1b2m/wBxj0CqroDKy5OgDbW5v9x4kqpRHuJrq/T7BO+Xk+z/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Figure 4: Banks [1994] ",
            "title": "Figure 4: Banks [1994] ",
            "src": "/static/3f30c941402abf000c7256449e8f882d/ff44c/lucy-banks.jpg",
            "srcSet": ["/static/3f30c941402abf000c7256449e8f882d/75985/lucy-banks.jpg 150w", "/static/3f30c941402abf000c7256449e8f882d/ff44c/lucy-banks.jpg 158w"],
            "sizes": "(max-width: 158px) 100vw, 158px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Figure 4: Banks [1994] `}</figcaption>{`
  `}</figure>


    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "141px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/dcba513a1096c12fdbc8fc4e02d0cd21/3a529/lucy-ward.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "173.0496453900709%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAjABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAEDBAUG/8QAFwEAAwEAAAAAAAAAAAAAAAAAAAECA//aAAwDAQACEAMQAAAB8/dT2FeAOGvJE6SKz0QBoAf/xAAeEAACAgICAwAAAAAAAAAAAAACAwABBDERExIyM//aAAgBAQABBQKLGii9QRBag1j/AGyy4i9IKgN5ebF+vWE6xiwGq//EABkRAAEFAAAAAAAAAAAAAAAAABEBAhAgIv/aAAgBAwEBPwFiGDin/8QAFxEAAwEAAAAAAAAAAAAAAAAAARAgQf/aAAgBAgEBPwErY//EABwQAAEFAAMAAAAAAAAAAAAAAAABEBExQQISIf/aAAgBAQAGPwIWceeWWyHRN9VpUlGooo//xAAfEAADAAEEAwEAAAAAAAAAAAAAAREhMUFRcWGx0fD/2gAIAQEAAT8hHV4kpq9iVcRBeUwRrdlYVX6MFHINXs8dYJoVQVtotx2+z9mMM3cn/9oADAMBAAIAAwAAABBgw4xzz//EABgRAQADAQAAAAAAAAAAAAAAAAEQETEg/9oACAEDAQE/ELSuEFEXrx//xAAXEQADAQAAAAAAAAAAAAAAAAABEBEg/9oACAECAQE/ECimH//EAB8QAQACAQQDAQAAAAAAAAAAAAEAESExQWHRUZHw8f/aAAgBAQABPxCKDo4RpUoc+CIAKrQG8tTSUi1f2O3qrbRtpMSKOFfaGK81DXLRPs4JtisHxceKGgxQROhBINzu7n3XcAqjLV4J/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Figure 4: Ward [1992]",
            "title": "Figure 4: Ward [1992]",
            "src": "/static/dcba513a1096c12fdbc8fc4e02d0cd21/3a529/lucy-ward.jpg",
            "srcSet": ["/static/dcba513a1096c12fdbc8fc4e02d0cd21/3a529/lucy-ward.jpg 141w"],
            "sizes": "(max-width: 141px) 100vw, 141px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Figure 4: Ward [1992]`}</figcaption>{`
  `}</figure>


    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/ea7be1f0b44f8279a60353385fd3a18d/56357/lucy-gold.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "169.44444444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAiABQDASIAAhEBAxEB/8QAGQAAAwEBAQAAAAAAAAAAAAAAAAIEAQMF/8QAFgEBAQEAAAAAAAAAAAAAAAAAAgEA/9oADAMBAAIQAxAAAAHw6Z7wkNFF1mK5jCL3hZOBt//EABwQAAICAgMAAAAAAAAAAAAAAAEDAhESMgATIf/aAAgBAQABBQLmIClagWWX1K16pRm2XitYzy4xJEF64i3+iAFf/8QAFxEBAAMAAAAAAAAAAAAAAAAAARAgQf/aAAgBAwEBPwEIyn//xAAYEQACAwAAAAAAAAAAAAAAAAACEQEQIP/aAAgBAgEBPwEppMsf/8QAHhAAAQQCAwEAAAAAAAAAAAAAAQACEBEhMRNBUXH/2gAIAQEABj8CVkZkfYyg3yLe432uS9xoIXlaX//EABwQAAIDAQEBAQAAAAAAAAAAAAABETFRIXFhgf/aAAgBAQABPyEkuo+F3pALR8CYs9I9JTJ01qSz0l9LZ4ThyyhRpd6frsGavD6SnF4f/9oADAMBAAIAAwAAABBnL3KP3//EABkRAAIDAQAAAAAAAAAAAAAAAAABEBFBIf/aAAgBAwEBPxDk3FpUWxoz/8QAGBEBAAMBAAAAAAAAAAAAAAAAARARMSH/2gAIAQIBAT8Q6BFrEyDI/8QAHxABAAIBBAMBAAAAAAAAAAAAAQARITFBUWFxgfCh/9oACAEBAAE/EGDBYjHTBr+xJWp1eiOCZVEANFLjcCfH0R5N+t64hYUArbpPj6ITL5AKPkR2RyBLy0vioaCvoQM0Hg5jAoLQrCBo9JwT/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Figure 4: Bastos et al. [1999]",
            "title": "Figure 4: Bastos et al. [1999]",
            "src": "/static/ea7be1f0b44f8279a60353385fd3a18d/56357/lucy-gold.jpg",
            "srcSet": ["/static/ea7be1f0b44f8279a60353385fd3a18d/56357/lucy-gold.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Figure 4: Bastos et al. [1999]`}</figcaption>{`
  `}</figure>
    <h1>{`References`}</h1>
    <ol>
      <li parentName="ol">{`DC Banks. Illumination in diverse codimensions. pages 327–334. ACM New York, NY, USA, 1994.`}</li>
      <li parentName="ol">{`R Bastos, K Hoff, W Wynn, and A Lastra. Increased photorealism for interactive architectural walkthroughs. pages 183–190. ACM New York, NY, USA, 1999.`}</li>
      <li parentName="ol">{`RL Cook and KE Torrance. A reflectance model for computer graphics. pages 307–316. ACM New York, NY, USA, 1981.`}</li>
      <li parentName="ol">{`GJ Ward. Measuring and modeling anisotropic reflection. pages 265–272. ACM New York, NY, USA, 1992.`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      